exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".yc-icon {\r\n    width: 16px;\r\n    height: 16px;\r\n    display: block;\r\n    float: right;\r\n    margin-left: -16px;\r\n}\r\n.yc-icon-success {\r\n    background: url(" + require("./success.png") + ") right no-repeat;\r\n}\r\n.yc-icon-wrong {\r\n    background: url(" + require("./wrong.png") + ") right no-repeat;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./assets/style.css
// module id = 5
// module chunks = 0